export const VIEWER_PAGE_PADDING = 40;
export const PANEL_SIZE = 230;
